import { RolesUsuario } from "./../../../../../../shared/enumeraciones/roles-usuario.enum";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { EstablecimientoEntry } from "src/app/shared/entrys/establecimiento.entry";
import { Router, ActivatedRoute } from "@angular/router";
import { CompletaInformacionComponent } from "../pasos/completa-informacion/completa-informacion.component";
import { SolicitudService } from "./solicitud.service";
import { Subscription, Observable } from "rxjs";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { TipoPrestador } from "src/app/shared/enumeraciones/tipo-prestador.enum";
import { TipoRnt } from "src/app/shared/enumeraciones/tipo-rnt.enum";
import { EstadosSolicitud } from "src/app/shared/enumeraciones/estados-solicitud.enum";
import { map } from "rxjs/operators";
import { DialogConfirmacionService } from "src/app/shared/services/dialog-confirmacion.service";
import { environment } from "src/environments/environment";
import { PlatformLocation } from "@angular/common";
import { TipoSolicitud } from "src/app/shared/enumeraciones/tipo-solicitud.enum";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";
import { CapacidadOperativaService } from '../pasos/capacidad/capacidad-operativa.service';
import { CapacidadTecnicaService } from '../pasos/capacidad/capacidad-tecnica.service';
import { TipoCapacidad } from "src/app/shared/enumeraciones/tipo-capacidad.enum";
import { EstadosRnt } from '../../../../../../shared/enumeraciones/estados-rnt.enum';

@Component({
  selector: "app-solicitudes",
  templateUrl: "./solicitudes.component.html",
  styleUrls: ["./solicitudes.component.scss"],
})
export class SolicitudesComponent implements OnInit, OnDestroy {
  camaraUrl: string;
  rutaAmazon;
  pasoActual: number;
  totalPasos: Array<number>;
  tipo_nueva = TipoSolicitud.Inscripcion;
  tipo_renovacion: number = TipoSolicitud.Renovacion;
  tipo_reactivacion: number = TipoSolicitud.Reactivacion;
  datoSolicitudSharedModel: DatoSolicitudSharedModel;
  suscripcion: Subscription;
  tipo_solicitud_actualizacion = TipoSolicitud.Actualizacion;
  municipio_id: string;
  tipo_suspendido_por_no_renovar : EstadosRnt.SuspendidoPorNoRenovar;
  guia = TipoRnt.Guia;
  constructor(
    private router: Router,
    private dataSharedService: DataSharedService,
    private solicitudService: SolicitudService,
    private authService: AuthService,
    private dialogConfirmacionService: DialogConfirmacionService,
    private locationPlatform: PlatformLocation,
    private enviromentGlobalService: EnviromentGlobalService,
    private capacidadTecnicaService: CapacidadTecnicaService
  ) {
    this.suscripcion = this.dataSharedService.data$.subscribe((dataShared) => {
      this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
    });


    this.pasoActual = 1;
    if (
      this.datoSolicitudSharedModel.data &&
      this.datoSolicitudSharedModel.data.codigo_camara
    ) {
      this.solicitudService
        .getCamara({
          codigo_camara: this.datoSolicitudSharedModel.data.codigo_camara,
          contenido_certificado_id: "LOGO_CAMARA",
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.camaraUrl = `${this.rutaAmazon}/${resultado.data.ruta}/${resultado.data.nombre_archivo}`;
          }
        });
    } else if (this.municipio_id) {
      this.cargarCamaraPorMunicipio();
    } else if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Guia ) {
      this.solicitudService
        .getCamara({
          codigo_camara: authService.getCamaraUser(),
          contenido_certificado_id: "LOGO_CAMARA",
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            // tslint:disable-next-line:max-line-length
            this.camaraUrl = `${this.rutaAmazon}/${resultado.data.ruta}/${
              resultado.data.nombre_archivo
            }?dummy=${Math.floor(Math.random() * (9999 * 1000)) + 1000}`;
          }
        });
    }
    this.rutaAmazon = enviromentGlobalService.amazonImage;
  }

  ngOnInit() {
    if (!this.datoSolicitudSharedModel.tipo_solicitud) {
      this.router.navigate(["/mis-establecimientos"]);
      return;
    }
    this.locationPlatform.onPopState((wind: any) => {
      if (wind.target.location.pathname === "/solicitud") {
        this.router.navigate(["/mis-establecimientos"]);
        return;
      }
    });

    this.solicitudService
      .sincronizarEnSolicitud({
        rnt_id: this.datoSolicitudSharedModel.data?.rnt_id,
        tipo_rnt_id: this.datoSolicitudSharedModel.data?.tipo_rnt_id,
        establecimiento_id: this.datoSolicitudSharedModel.data?.establecimiento_id,
        matricula: this.datoSolicitudSharedModel.data?.matricula,
        codigo_camara: this.datoSolicitudSharedModel.data?.codigo_camara,
        direccion_comercial : this.datoSolicitudSharedModel.data?.direccion_comercial,
        municipio_id : this.datoSolicitudSharedModel.data?.municipio_id
      })
      .subscribe(
        (infoSync) => {
          if (infoSync.result) {
            this.continueNgOnInit();
          } else {
            this.continueNgOnInit();
          }
        },
        (noInfoSync) => {
          this.router.navigate(["mis-establecimientos"]);
        }
      );
  }

  async continueNgOnInit() {
    let tieneCapacidades = false;
    const responseConfigCapacidadesTecnicas = await this.capacidadTecnicaService.getConfigCapacidades( TipoCapacidad.Tecnica, this.datoSolicitudSharedModel.tipo_rnt).toPromise();
    const responseConfigCapacidadesOperativas = await this.capacidadTecnicaService.getConfigCapacidades( TipoCapacidad.Operativa, this.datoSolicitudSharedModel.tipo_rnt).toPromise();
    this.datoSolicitudSharedModel.capacidadesTecnicas = responseConfigCapacidadesTecnicas;
    this.datoSolicitudSharedModel.capacidadesOperativas = responseConfigCapacidadesOperativas;
    if ((responseConfigCapacidadesTecnicas.data !== null && responseConfigCapacidadesTecnicas.data[0].Se_Muestra_No_Comerciante) ||
      ( responseConfigCapacidadesOperativas.data !== null && responseConfigCapacidadesOperativas.data[0].Se_Muestra_No_Comerciante)) {
      tieneCapacidades = true;
    }

    if (
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Inscripcion ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Actualizacion ||
      this.datoSolicitudSharedModel.data.excepcion_municipio_pago_fontur
    ) {
      if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles) {
        this.totalPasos = Array<number>(4);
      } else if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.PlataformaDigitales){
        this.totalPasos = Array<number>(4);
      }else {
        this.totalPasos = Array<number>(4);
      }
    } else if (
      this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion
    ) {
      this.totalPasos = Array<number>(5);
    } else if(
      this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
      this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion
    ){
      this.totalPasos = Array<number>(6);
    }

    //#region Continuar Solicitud
    if (
      this.datoSolicitudSharedModel.data &&
      (this.datoSolicitudSharedModel.estado_solicitud ===
        EstadosSolicitud.EnProceso ||
        this.datoSolicitudSharedModel.estado_solicitud ===
          EstadosSolicitud.Devuelto)
    ) {
      this.solicitudService
        .get(this.datoSolicitudSharedModel.data)
        .subscribe((resultado) => {
          try {
            if (resultado.result) {
              if (
                this.datoSolicitudSharedModel.tipo_solicitud ===
                  TipoSolicitud.Renovacion 
                 &&
                !this.datoSolicitudSharedModel.data
                  .excepcion_municipio_pago_fontur
              ) {
                if (
                  this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles
                ) {
                  this.totalPasos = Array<number>(5);
                } else if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.PlataformaDigitales){
                  this.totalPasos = Array<number>(5);
                } else {
                  this.totalPasos = Array<number>(5);
                }
              }

              this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
                data: {
                  ...this.datoSolicitudSharedModel.data,
                  ...resultado.data,
                },
                tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
                estado_solicitud: this.datoSolicitudSharedModel
                  .estado_solicitud,
                tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
                
              });



              if (
                this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles
              ) {
                this.router.navigate([
                  "solicitud/completa-informacion-inmueble",
                ]);
              } else if (
                this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.PlataformaDigitales
              ) {
                this.router.navigate([
                  "solicitud/completa-informacion-plataformas",
                ]);
              } else {
                if (this.datoSolicitudSharedModel.tipo_rnt !== TipoRnt.Guia) {
                  this.router.navigate(["solicitud/completa-informacion"]);
                } else {
                  this.router.navigate(["solicitud/completa-informacion-guia"]);
                }
              }
            } else {
              throw resultado.control;
            }
          } catch (error) {
            this.router.navigate(["mis-establecimientos"]);
          }
        });
      //#endregion
    } else {
      if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles) {
        this.router.navigate(["solicitud/completa-informacion-inmueble"]);
      } else {
        if (this.datoSolicitudSharedModel.tipo_rnt == TipoRnt.PlataformaDigitales) {
          this.router.navigate(["solicitud/completa-informacion-plataformas"]);
        }else if (this.datoSolicitudSharedModel.tipo_rnt !== TipoRnt.Guia) {
          this.router.navigate(["solicitud/completa-informacion"]);
        } else {
          this.router.navigate(["solicitud/completa-informacion-guia"]);
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.suscripcion.unsubscribe();
  }

  onPasoActual(paso: CompletaInformacionComponent) {
    paso.pasoActual.subscribe((resultado) => {
      if (resultado.totalPasos) {
        this.totalPasos = Array<number>(resultado.totalPasos);
      } else if (resultado.municipio_id) {
        this.municipio_id = resultado.municipio_id;
        this.cargarCamaraPorMunicipio();
      } else {
        this.pasoActual = resultado;
      }
    });
  }
  cargarCamaraPorMunicipio() {
    this.camaraUrl = null;
    this.solicitudService
      .getCamaraPorMunicipio(this.municipio_id)
      .subscribe((resultado) => {
        if (resultado.result) {
          this.camaraUrl = `${this.rutaAmazon}/${resultado.data.ruta}/${resultado.data.nombre_archivo}`;
        }
      });
  }
}
